import { Injectable } from '@angular/core';
import { WindowRef } from '@Common/browser';

const ExtId = 'fastx@starnet.com'

export class ExtensionNotEnabledError extends Error{};
export class ExtensionDivMissingError extends Error{};
export class TimeoutError extends Error{};

@Injectable()
export class ExtensionService {
  isEnabled;
  extensions = {};
  myDiv: HTMLElement
  constructor() {}
  
  async init() {
    let myDiv = document.getElementById('fastx@starnet.com');
    if(!myDiv)
      throw new ExtensionDivMissingError("Missing extension Div");
    this.myDiv = myDiv;
    
    // try {
    //   let extensionId = 'gfpnahdglhbkdgbkolmigjakbkpjhfof';
    //   await fetch(`chrome-extension://${extensionId}/fastx-48.png`);
    // } catch (e) {
    //     throw e;
    // }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error("extension failed to load"));
      }, 5000);
      this.myDiv.addEventListener('extension-ready', e => {
        this.isEnabled = true;
        resolve(this.isEnabled);
      }); 
    });
  }
  protected _isEnabled() {
    if(!this.isEnabled)
      throw new ExtensionNotEnabledError("Extension not enabled");
  }
 

  enabled() {
    return this.isEnabled;
  }
  sendMessage(name, details) {
    return new Promise((resolve, reject) => {
      let el = document.getElementById(ExtId);
      if(!el)
        return reject(new Error('Missing Extension Element'));

      el.dispatchEvent(new CustomEvent(name , { detail: details }));
      el.addEventListener(name + '-ready', (evt:CustomEvent) => {
        let j = {} as any;
        if(typeof evt.detail === 'string') {
          try {
             j = JSON.parse(evt.detail);

          } catch(e) {}
        } else {
          j = evt.detail;
        }
        if(j.result) {
          return resolve(j.result);
        } else if(j.error) {
          return reject(j.error);
        }
        resolve(j);
      }, { once: true});
      setTimeout(() => {
        reject(new Error('Event time out'));
      }, 5000);
    })
  }
}
